import * as ActionIds from "../constants/synonyms";

import type { SynonymsActions } from "../actions/synonyms";
import type { SynonymsState } from "../models/synonyms";

const EMPTY_SYNONYMS_STATE: SynonymsState = {
  filter: {
    encounterType: null,
    facility: null,
    codeType: null,
    itemType: null,
    top: 20,
    search: "",
    skip: 0,
    order: [{ field: "SynonymText", asc: true }],
  },
  busy: 0,
  synonyms: null,
};

export function synonymsReducer(
  state: SynonymsState = EMPTY_SYNONYMS_STATE,
  action: SynonymsActions,
): SynonymsState {
  switch (action.type) {
    case ActionIds.SYNONYMS_END_WAIT:
      if (state.busy <= 0) {
        console.error("END_WAIT happens more than BEGIN_WAIT");
        return state;
      }
      return {
        ...state,
        busy: state.busy - 1,
      };
    case ActionIds.SYNONYMS_BEGIN_WAIT:
      return {
        ...state,
        busy: state.busy + 1,
      };
    case ActionIds.SYNONYMS_UPDATE_SYNONYMS:
      return {
        ...state,
        filter: action.filter,
        synonyms: action.synonyms,
      };
    default:
      return state;
  }
}
